// @ts-nocheck
import { initialState } from './reducer';
// import * as reducer from './reducer';
const availabilitySelector = (state) => state.availability || initialState;

export const getAvailabilityInfo = (state) => {
	return availabilitySelector(state).info;
};
